// 节流方法
export function throttle<T extends (...args: any[]) => void>(
  func: T,
  delay: number,
): (...args: Parameters<T>) => void {
  let lastCallTimestamp = 0;

  return function (...args: Parameters<T>): void {
    const now = Date.now();
    if (now - lastCallTimestamp >= delay) {
      func(...args);
      lastCallTimestamp = now;
    }
  };
}

export function openUrl(link: string) {
  const u = navigator.userAgent;
  const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (isiOS) {
    // ios终端
    const a = document.createElement("a");
    a.setAttribute("href", link);
    a.setAttribute("target", "_self");
    const id = new Date().getTime() + "";
    a.setAttribute("id", id);
    // 防止反复添加
    if (!document.getElementById(id)) document.body.appendChild(a);
    a.click();
  } else {
    setTimeout(() => {
      const a = document.createElement("a");
      a.setAttribute("href", link);
      a.setAttribute("target", "_blank");
      const id = new Date().getTime() + "";
      a.setAttribute("id", id);
      // 防止反复添加
      if (!document.getElementById(id)) document.body.appendChild(a);
      a.click();
    }, 300);
  }
}

export function debounce(
  func: (...args: any[]) => any,
  delay: number,
): (...args: any[]) => void {
  let timer: NodeJS.Timeout | null = null;

  return (...args: any[]) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      func(...args);
    }, delay);
  };
}
